import { useState } from "react";
import { toast } from "sonner";
import { Send, Mail } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import { Reveal } from "./Reveal";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSending(true);
    try {
      const { data } = await api.post("/subscribe", { email });
      toast.success(data.message || "¡Suscripción confirmada!");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSending(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="bg-cream py-20 md:py-28 border-t border-line">
      <div className="max-w-3xl mx-auto px-5 md:px-10 text-center">
        <Reveal>
          <Mail size={30} strokeWidth={1} className="mx-auto text-rose" />
          <span className="block mt-5 text-[11px] uppercase tracking-[0.3em] text-rose">
            Lista privada
          </span>
          <h2 className="mt-4 font-serif font-light text-3xl md:text-5xl leading-none">
            Sé la primera en <span className="italic text-rose">enterarte</span>
          </h2>
          <p className="text-taupe mt-4 font-light max-w-md mx-auto">
            Nuevos lanzamientos, ofertas exclusivas y catas privadas. Directo a tu correo.
          </p>

          <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              data-testid="newsletter-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@correo.com"
              className="flex-1 bg-transparent border-b border-line py-3 text-center sm:text-left focus:outline-none focus:border-rose transition-colors font-light"
            />
            <button
              data-testid="newsletter-submit"
              type="submit"
              disabled={sending}
              className="inline-flex items-center justify-center gap-2 bg-espresso text-cream rounded-full px-7 py-3.5 text-xs uppercase tracking-[0.2em] hover:bg-rose transition-colors disabled:opacity-60"
            >
              {sending ? "Enviando..." : "Suscribirme"}
              <Send size={14} />
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
